import {CodingAssistantButton} from '@github-ui/coding-assistant-button'

type StartWorkButtonProps = {
  url: string
  planBody: string
}

export function StartWorkButton({url, planBody}: StartWorkButtonProps) {
  return (
    <CodingAssistantButton
      url={url}
      buttonLabel="Start work"
      promptBuilder={(issueUrl: string) =>
        `I've created a plan for ${issueUrl}, please implement this plan:\n\n${planBody.trim()}`
      }
      size="small"
    />
  )
}
